var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartSparkline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 36,
    viewBox: "0 0 53 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 19.5C0.666992 18.3954 1.56242 17.5 2.66699 17.5C3.77156 17.5 4.66699 18.3954 4.66699 19.5V35.5H0.666992V19.5Z",
    fill: "#00BBAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 2.5C8.66699 1.39543 9.56242 0.5 10.667 0.5C11.7716 0.5 12.667 1.39543 12.667 2.5V35.5H8.66699V2.5Z",
    fill: "#00BBAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 15.5C16.667 14.3954 17.5624 13.5 18.667 13.5C19.7716 13.5 20.667 14.3954 20.667 15.5V35.5H16.667V15.5Z",
    fill: "#00BBAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 15.5C24.667 14.3954 25.5624 13.5 26.667 13.5C27.7716 13.5 28.667 14.3954 28.667 15.5V35.5H24.667V15.5Z",
    fill: "#00BBAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.667 6.5C32.667 5.39543 33.5624 4.5 34.667 4.5C35.7716 4.5 36.667 5.39543 36.667 6.5V35.5H32.667V6.5Z",
    fill: "#00BBAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.667 17.5C40.667 16.3954 41.5624 15.5 42.667 15.5C43.7716 15.5 44.667 16.3954 44.667 17.5V35.5H40.667V17.5Z",
    fill: "#00BBAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.667 15.5C48.667 14.3954 49.5624 13.5 50.667 13.5C51.7716 13.5 52.667 14.3954 52.667 15.5V35.5H48.667V15.5Z",
    fill: "#00BBAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSparkline);
export default __webpack_public_path__ + "static/media/chart_sparkline.f3c115efc1822b24265330f8182a3a77.svg";
export { ForwardRef as ReactComponent };